import {
  play,
  pause,
} from "../../components/BackgroundVideo/initBackgroundVideo.js";

const pauseVideos = (root) => {
  // Pause Sitecore videos
  root.querySelectorAll(".js-background-video").forEach((el) => {
    const buttonEl = el.querySelector(".js-background-video-button");
    const videoEl = el.querySelector(".js-background-video-media");
    pause({ buttonEl, videoEl });
  });

  // Pause YouTube videos
  root.querySelectorAll(".js-youtube-video-mount iframe").forEach((iframe) => {
    iframe.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "https://www.youtube-nocookie.com",
    );
  });
};

/**
 * @param {HTMLElement} wrapper
 * @param {"sitecore" | "youtube"} platform
 */
const playVideo = (wrapper, platform) => {
  if (platform === "youtube") {
    const youtubeAppRoot = wrapper.querySelector(".youtube-video");
    const id = youtubeAppRoot.id;
    if (!id) return;

    const event = new CustomEvent("text-over-media-modal-open", {
      detail: {
        id,
      },
    });
    window.dispatchEvent(event);
  } else {
    const el = wrapper.querySelector(".js-background-video");
    const buttonEl = el.querySelector(".js-background-video-button");
    const videoEl = el.querySelector(".js-background-video-media");

    play({ el, buttonEl, videoEl });
  }
};

const initLinkVideo = (root) => {
  if (document.body.classList.contains("is-page-editor")) return;

  const links = [...root.querySelectorAll(".js-text-over-media-link-video")];
  const modal = root.querySelector(".js-text-over-media-modal");

  if (links.length === 0 || !modal) return;

  const closeButton = modal.querySelector(".js-text-over-media-close-button");

  // show the modal
  links.forEach((link) => {
    link.addEventListener("click", (event) => {
      modal.showModal();
      modal.addEventListener(
        "animationend",
        (event) => {
          if (event.animationName === "modal-fade-in") {
            const isMobile = window.matchMedia("(max-width: 680px)").matches;
            const desktopVideoWrapper = modal.querySelector(
              ".text-over-media__video-wrapper--desktop",
            );
            const mobileVideoWrapper = modal.querySelector(
              ".text-over-media__video-wrapper--mobile",
            );
            let video;

            if (isMobile) {
              video = mobileVideoWrapper || desktopVideoWrapper;
            } else {
              video = desktopVideoWrapper;
            }

            if (!video) return;

            playVideo(video, video.dataset.platform);

            closeButton.focus();
          }
        },
        { once: true },
      );
    });
  });

  // listen for close event (esc key)
  modal.addEventListener("close", (event) => {
    pauseVideos(modal);

    const isMobile = window.matchMedia("(max-width: 680px)").matches;

    const mobileLink = links.find((link) =>
      link.classList.contains("text-over-media__link--mobile"),
    );
    const desktopLink = links.find((link) =>
      link.classList.contains("text-over-media__link--desktop"),
    );
    const targetLink = isMobile ? mobileLink || desktopLink : desktopLink;

    targetLink.focus();
  });

  // init close button
  closeButton.addEventListener("click", (event) => {
    modal.close();
  });

  // add clickaway
  modal.addEventListener("click", (event) => {
    if (event.target === event.currentTarget) {
      modal.close();
    }
  });

  // if mobile + desktop video, close modal on breakpoint switch
  if (links.length > 1) {
    const mediaQuery = window.matchMedia("(max-width: 680px)");
    mediaQuery.addEventListener("change", () => modal.close());
  }
};

const initAnimatedTitles = (el) => {
  let animatedTitles = el.querySelectorAll(
    ".js-text-over-media__animated-title span",
  );

  // if there's only one item
  if (animatedTitles?.length < 2) {
    return;
  }

  const animatedTitleWrapper = el.querySelector(
    ".js-text-over-media__animated-title",
  );

  // Make the first title also be the last title for animations
  const clone = animatedTitles[0].cloneNode(true);
  animatedTitleWrapper.append(clone);

  animatedTitles = el.querySelectorAll(
    ".js-text-over-media__animated-title span",
  );

  animatedTitles[0].classList.add("is-active");

  animatedTitleWrapper.classList.add("text-over-media__title-middle--animate");

  let activeTitle = 0;
  let paused = false;
  let interval = null;

  const loop = () => {
    interval = window.setInterval(() => {
      if (!paused) {
        const oldActiveTitle = activeTitle;
        activeTitle++;
        animatedTitles[activeTitle].classList.add("is-active");
        animatedTitles[oldActiveTitle].classList.remove("is-active");

        // switch the last and first slides after animating
        if (activeTitle === animatedTitles.length - 1) {
          setTimeout(() => {
            animatedTitles[0].classList.add("is-active");
            animatedTitles[activeTitle].classList.remove("is-active");
            activeTitle = 0;
          }, 500); // CSS animation speed
        }
      }
    }, 3250);
  };

  loop();

  animatedTitleWrapper.addEventListener("mouseenter", () => {
    paused = true;
  });

  animatedTitleWrapper.addEventListener("mouseleave", () => {
    paused = false;
  });

  animatedTitleWrapper.addEventListener("click", () => {
    if (interval) {
      window.clearInterval(interval);
      animatedTitleWrapper.setAttribute("aria-pressed", "true");
      interval = null;
    } else {
      animatedTitleWrapper.setAttribute("aria-pressed", "false");
      loop();
    }
  });
};

const initAnimatedGates = (el) => {
  // Initialize animated gates
  console.log("Initializing animated gates...");
  if (el.classList.contains("js-text-over-media--animated-gate")) {
    el.classList.add("is-open");
  }
};

export default () => {
  document.querySelectorAll(".js-text-over-media").forEach((el) => {
    initLinkVideo(el);
    initAnimatedTitles(el);
    initAnimatedGates(el);
  });
};
